import script from "./OauthButtonVK.vue?vue&type=script&setup=true&lang=js"
export * from "./OauthButtonVK.vue?vue&type=script&setup=true&lang=js"

import "./OauthButtonVK.vue?vue&type=style&index=0&id=7698dc5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7698dc5a"]])

export default __exports__